export async function atlasApi(endpoint, values, signal) {
    const response = await fetch(endpoint, values ? {
        method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        body: new URLSearchParams(values).toString(), signal
    } : { signal });
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || 'Atlas request failed. Please retry.');
    return data;
}
